import React, { useEffect, useState } from 'react'
import dynamic from 'next/dynamic'
import {
  clientData,
  whatWeDoData,
  serviceData,
  messageSectionData,
  ourValuesData,
  OurAdvisorsData,
  feedbackData,
  OurSpecialist,
  OurUSP
} from '../components/About/data/ClientData'
import Navbar from "../components/Layouts/Navbar";
import HeroBanner from '../components/Common/HeroBanner';
import DButton from '../components/elements/DButton';
import Breadcrumb from '../components/Layouts/Breadcrumb';
import WhatWeDo from '../components/About/WhatWeDo';
import MeetSpecialist from '../components/About/MeetSpecialist';
import Head from 'next/head';
import OurUsps from '../components/About/OurUsps';
const Footer = dynamic(() => import('../components/Layouts/Footer', { ssr: false }));
const Service = dynamic(() => import('../components/About/Service', { ssr: false }));
const MessageSection = dynamic(() => import('../components/About/MessageSection', { ssr: false }));
const OurValues = dynamic(() => import('../components/About/OurValues', { ssr: false }));
const Clients = dynamic(() => import('../components/About/Clients', { ssr: false }));
const Feedback = dynamic(() => import('../components/About/Feedback', { ssr: false }));
const OurAdvisors = dynamic(() => import('../components/About/OurAdvisors', { ssr: false }));
const Projects = dynamic(() => import('../components/About/Projects'));
import axios from 'axios';

const AboutUs = () => {

  const [scrolled, setScrolled] = useState(0)
  const [scrolledStatus, setScrolledStatus] = useState(false)


  useEffect(() => {
    const onScroll = () => setScrolled(window.pageYOffset);
    window.removeEventListener('scroll', onScroll);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);


  useEffect(() => {
    if (scrolled > 30) {
      setScrolledStatus(true)
    }
  }, [scrolled])



  return (
    <>
      
      <Navbar />
      <div>
        <HeroBanner
          background={process.env.IMG_CDN + "img/about-us/png/about-us.png"}
          title={<>Healthcare Market Research and Business Consulting</>}
          description={<>One-stop solution for all of your Pharma Market Research, Consulting and Business needs</>}
          buttonOnBanner={<>
            <div className="flex flex-col md:flex-row sm:grid-cols-4 grid-cols-1">
              <DButton title="Report Store" redirect="/report-store.php" customClass='md:w-full w-8/12 mb-3 md:mb-0' />
              <DButton title="Business Consulting" redirect="/consulting" customClass='md:w-full w-8/12' />
            </div>
          </>}
        />
        <Breadcrumb />
        <WhatWeDo data={whatWeDoData} />
        {scrolledStatus && <>
          <Service title="Our Services" data={serviceData} />
          <MessageSection data={messageSectionData} />
        </>}
      </div>
      {scrolledStatus && <>
        <OurValues data={ourValuesData} />
        <OurAdvisors data={OurAdvisorsData} />
      </>}
      <MeetSpecialist title="Meet Our Specialists" data={OurSpecialist} />
      <Projects />
      <OurUsps data={OurUSP} />
      <Feedback data={feedbackData} title="Customer Feedback" />
      <Clients data={clientData} title="Our Clients" description="Trusted By World's Best Companies" />
      
      {scrolledStatus && <>
        <Footer />
      </>}

    </>
  )
}


AboutUs.getInitialProps = async (NextPageContext) => {
  const slugData = NextPageContext.pathname
  try {
      const response = await axios.get(process.env.API_URL + '/meta' + slugData);
      return {
          title: (response?.data.meta_title) ? response?.data.meta_title : "Healthcare Market Research Reports & Consulting Firm | DelveInsight",
          description: (response?.data.meta_description) ? response?.data.meta_description : "DelveInsight is a pioneer in Healthcare Market Research Reports & Consulting Services. We advise Pharma leaders on making strategic decisions across all therapy areas & geographies.",
          keywords: (response?.data.meta_keywords) ? response?.data.meta_keywords : "pharmaceutical business consulting, market research company, pharma consulting, biotech consulting, pharma market research, pharma market insights, biotech consulting,  pharma consulting service, pharma leading, market trends.",
      }
  } catch (error) {
      console.error('Error fetching data:', error.message);
      return {
          title: "Healthcare Market Research Reports & Consulting Firm | DelveInsight",
          description: "DelveInsight is a pioneer in Healthcare Market Research Reports & Consulting Services. We advise Pharma leaders on making strategic decisions across all therapy areas & geographies.",
          keywords: "pharmaceutical business consulting, market research company, pharma consulting, biotech consulting, pharma market research, pharma market insights, biotech consulting,  pharma consulting service, pharma leading, market trends.",
      };
  }
}

export default AboutUs;




